module.exports = __webpack_public_path__ + "1791188489487/images/sprite-skin-flat.bcdb14f.png";